module.exports = __webpack_public_path__ + "831f177f8b717a48896062efe7246ee8.png";